export default __webpack_public_path__ + "static/media/t.db566574.glb";